<template>
    <div class="panel panel-default m-t-md">
        <div class="panel-heading">Voice Correction</div>
        <div class="panel-body">
            <a
                    type="button"
                    class="btn btn-default pull-left"
                    download :href="voiceDownloadUrl"
                    onclick="
                           var cl = this.firstChild.classList;
                           cl.remove('fa-download');
                           cl.add('fa-spinner');
                           cl.add('fa-spin');
                           setTimeout(function(){cl.remove('fa-spin'); cl.remove('fa-spinner'); cl.add('fa-music'); }, 30000);
                        "
            >
                <i class="fa fa-music"></i> Download Original Master Voice
            </a>
            <div style="clear: both" class="pull-left">
                <videoproject-file
                        id="voice_english_meta"
                        :file_names="lessonCode+'_XX_en.aif'"
                        enforce_filename="1"
                        field_name="voice_english"
                        icon="fa fa-music"
                        isrequired="true"
                        :lesson_code="lessonCode"
                ></videoproject-file>
            </div>
            <div style="color:darkred; max-width: 400px" id="audioAffectedLabel" class="pull-left">
                <br><br>
                <b>Caution:</b><br>
                Uploading a new English Master voice will cause
                re-recordings of all completed English voices for countries that
                need a localization.
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            'lessonCode': String,
            'voiceDownloadUrl': String,
        },

        data: function() {
            return {

            };
        },
    };
</script>
